"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholeLifeValidationUtils = void 0;
var ActualAgeToMinTotalFaceCPL10 = require("../../config/coverpath/CPL10/ActualAgeToMinTotalFace.json");
var ActualAgeToMinTotalFaceCPL10LowFaceWholeLifeEnabled = require("../../config/coverpath/CPL10/ActualAgeToMinTotalFace-LowFaceWholeLifeEnabled.json");
var ActualAgeToMaxTotalFaceCPL10 = require("../../config/coverpath/CPL10/ActualAgeToMaxTotalFace.json");
var PaymentFrequencyToDividendOptionsCPL10 = require("../../config/coverpath/CPL10/PaymentFrequencyToDividendOptions.json");
var ActualAgeToMaxTotalFaceNonUsCitizenCPL10 = require("../../config/coverpath/CPL10/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var ActualAgeToMinTotalFaceCPL12 = require("../../config/coverpath/CPL12/ActualAgeToMinTotalFace.json");
var ActualAgeToMinTotalFaceCPL12LowFaceWholeLifeEnabled = require("../../config/coverpath/CPL12/ActualAgeToMinTotalFace-LowFaceWholeLifeEnabled.json");
var ActualAgeToMaxTotalFaceCPL12 = require("../../config/coverpath/CPL12/ActualAgeToMaxTotalFace.json");
var PaymentFrequencyToDividendOptionsCPL12 = require("../../config/coverpath/CPL12/PaymentFrequencyToDividendOptions.json");
var ActualAgeToMaxTotalFaceNonUsCitizenCPL12 = require("../../config/coverpath/CPL12/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var ActualAgeToMinTotalFaceCPL15 = require("../../config/coverpath/CPL15/ActualAgeToMinTotalFace.json");
var ActualAgeToMinTotalFaceCPL15LowFaceWholeLifeEnabled = require("../../config/coverpath/CPL15/ActualAgeToMinTotalFace-LowFaceWholeLifeEnabled.json");
var ActualAgeToMaxTotalFaceCPL15 = require("../../config/coverpath/CPL15/ActualAgeToMaxTotalFace.json");
var PaymentFrequencyToDividendOptionsCPL15 = require("../../config/coverpath/CPL15/PaymentFrequencyToDividendOptions.json");
var ActualAgeToMaxTotalFaceNonUsCitizenCPL15 = require("../../config/coverpath/CPL15/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var ActualAgeToMinTotalFaceCPL20 = require("../../config/coverpath/CPL20/ActualAgeToMinTotalFace.json");
var ActualAgeToMinTotalFaceCPL20LowFaceWholeLifeEnabled = require("../../config/coverpath/CPL20/ActualAgeToMinTotalFace-LowFaceWholeLifeEnabled.json");
var ActualAgeToMaxTotalFaceCPL20 = require("../../config/coverpath/CPL20/ActualAgeToMaxTotalFace.json");
var PaymentFrequencyToDividendOptionsCPL20 = require("../../config/coverpath/CPL20/PaymentFrequencyToDividendOptions.json");
var ActualAgeToMaxTotalFaceNonUsCitizenCPL20 = require("../../config/coverpath/CPL20/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var ActualAgeToMinTotalFaceCPL65 = require("../../config/coverpath/CPL65/ActualAgeToMinTotalFace.json");
var ActualAgeToMinTotalFaceCPL65LowFaceWholeLifeEnabled = require("../../config/coverpath/CPL65/ActualAgeToMinTotalFace-LowFaceWholeLifeEnabled.json");
var ActualAgeToMaxTotalFaceCPL65 = require("../../config/coverpath/CPL65/ActualAgeToMaxTotalFace.json");
var PaymentFrequencyToDividendOptionsCPL65 = require("../../config/coverpath/CPL65/PaymentFrequencyToDividendOptions.json");
var ActualAgeToMaxTotalFaceNonUsCitizenCPL65 = require("../../config/coverpath/CPL65/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var ActualAgeToMinTotalFaceCPL100 = require("../../config/coverpath/CPL100/ActualAgeToMinTotalFace.json");
var ActualAgeToMinTotalFaceCPL100LowFaceWholeLifeEnabled = require("../../config/coverpath/CPL100/ActualAgeToMinTotalFace-LowFaceWholeLifeEnabled.json");
var ActualAgeToMaxTotalFaceCPL100 = require("../../config/coverpath/CPL100/ActualAgeToMaxTotalFace.json");
var PaymentFrequencyToDividendOptionsCPL100 = require("../../config/coverpath/CPL100/PaymentFrequencyToDividendOptions.json");
var ActualAgeToMaxTotalFaceNonUsCitizenCPL100 = require("../../config/coverpath/CPL100/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var Product_1 = require("../../tasks/coverpath/dependencies/Product");
var ValidationUtils_1 = require("../ValidationUtils");
var WholeLifeValidationUtils = /** @class */ (function () {
    function WholeLifeValidationUtils() {
    }
    WholeLifeValidationUtils.isValidDOBForProduct = function (productCode, dob, twoCharStateCode) {
        var daysOld = ValidationUtils_1.ValidationUtils.getActualAgeInDays(dob);
        if (daysOld < 15) {
            return {
                isValid: false,
                message: 'Juveniles younger than 15 days old cannot be covered at this time'
            };
        }
        var actualAgeInYears = ValidationUtils_1.ValidationUtils.getActualAgeInFractionalYears(dob);
        if (twoCharStateCode === 'WA') {
            if (actualAgeInYears >= 15 && actualAgeInYears <= 17) {
                return {
                    isValid: false,
                    message: 'Juveniles between the ages of 15 and 17 cannot be covered at this time in this state'
                };
            }
        }
        var actualAgeLookUpKey = WholeLifeValidationUtils.getAgeLookUpKeyForActualAge(actualAgeInYears);
        var config = WholeLifeValidationUtils.getConfigForProduct(productCode);
        if (config.ActualAgeToMinTotalFace[actualAgeLookUpKey]) {
            return {
                isValid: true
            };
        }
        else {
            return {
                isValid: false,
                message: "Selected product not allowed for this age"
            };
        }
    };
    WholeLifeValidationUtils.isValidDividendOption = function (productCode, dividendOption, paymentFrequency) {
        var paymentFrequencyToAllowedDividendOptions = WholeLifeValidationUtils.getConfigForProduct(productCode).PaymentFrequencyToDividendOptions;
        var dividendOptionAllowed = paymentFrequencyToAllowedDividendOptions[paymentFrequency].includes(dividendOption);
        if (dividendOptionAllowed) {
            return {
                isValid: true
            };
        }
        else {
            return {
                isValid: false,
                message: 'The chosen dividend option is not allowed for the selected payment frequency'
            };
        }
    };
    WholeLifeValidationUtils.isValidFaceAmount = function (productCode, faceAmount, rtrAmount, dob, healthClass, lowFaceWholeLifeEnabled, isUsCitizen, lowFaceWL10Enabled) {
        if (lowFaceWholeLifeEnabled === void 0) { lowFaceWholeLifeEnabled = true; }
        if (isUsCitizen === void 0) { isUsCitizen = true; }
        if (lowFaceWL10Enabled === void 0) { lowFaceWL10Enabled = true; }
        var actualAge = ValidationUtils_1.ValidationUtils.getActualAgeInFractionalYears(dob);
        var actualAgeLookUpKey = WholeLifeValidationUtils.getAgeLookUpKeyForActualAge(actualAge);
        var config = WholeLifeValidationUtils.getConfigForProduct(productCode, lowFaceWholeLifeEnabled, lowFaceWL10Enabled);
        var minAllowed = config.ActualAgeToMinTotalFace[actualAgeLookUpKey];
        //the min face config is either 1) a map of age to number, or 2) a map of age to a map of health class to number
        if (typeof minAllowed === 'object') {
            if (healthClass.includes("TABLE")) {
                healthClass = healthClass.includes("TOBACCO") ? "TABLE_TOBACCO" : "TABLE";
            }
            minAllowed = minAllowed[healthClass];
        }
        var maxAllowed = isUsCitizen ? config.ActualAgeToMaxTotalFace[actualAgeLookUpKey] : config.ActualAgeToMaxTotalFaceNonUsCitizen[actualAgeLookUpKey];
        if (!minAllowed || !maxAllowed) {
            return {
                isValid: false,
                message: "Selection not allowed given age"
            };
        }
        if (faceAmount < minAllowed) {
            return {
                isValid: false,
                minAllowed: minAllowed,
                message: "Must be at least ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(minAllowed))
            };
        }
        if (faceAmount + rtrAmount > maxAllowed) {
            return {
                isValid: false,
                maxAllowed: maxAllowed,
                message: "Cannot exceed ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(maxAllowed))
            };
        }
        return {
            isValid: true
        };
    };
    WholeLifeValidationUtils.getConfigForProduct = function (productCode, lowFaceWholeLifeEnabled, lowFaceWL10Enabled) {
        if (lowFaceWholeLifeEnabled === void 0) { lowFaceWholeLifeEnabled = true; }
        if (lowFaceWL10Enabled === void 0) { lowFaceWL10Enabled = true; }
        switch (productCode) {
            case 'CPL10':
            case 'CPL10A':
                return {
                    ActualAgeToMinTotalFace: lowFaceWL10Enabled ? ActualAgeToMinTotalFaceCPL10LowFaceWholeLifeEnabled : ActualAgeToMinTotalFaceCPL10,
                    ActualAgeToMaxTotalFace: ActualAgeToMaxTotalFaceCPL10,
                    PaymentFrequencyToDividendOptions: PaymentFrequencyToDividendOptionsCPL10,
                    ActualAgeToMaxTotalFaceNonUsCitizen: ActualAgeToMaxTotalFaceNonUsCitizenCPL10
                };
            case 'CPL12':
                return {
                    ActualAgeToMinTotalFace: lowFaceWholeLifeEnabled ? ActualAgeToMinTotalFaceCPL12LowFaceWholeLifeEnabled : ActualAgeToMinTotalFaceCPL12,
                    ActualAgeToMaxTotalFace: ActualAgeToMaxTotalFaceCPL12,
                    PaymentFrequencyToDividendOptions: PaymentFrequencyToDividendOptionsCPL12,
                    ActualAgeToMaxTotalFaceNonUsCitizen: ActualAgeToMaxTotalFaceNonUsCitizenCPL12
                };
            case 'CPL15':
            case 'CPL15A':
                return {
                    ActualAgeToMinTotalFace: lowFaceWholeLifeEnabled ? ActualAgeToMinTotalFaceCPL15LowFaceWholeLifeEnabled : ActualAgeToMinTotalFaceCPL15,
                    ActualAgeToMaxTotalFace: ActualAgeToMaxTotalFaceCPL15,
                    PaymentFrequencyToDividendOptions: PaymentFrequencyToDividendOptionsCPL15,
                    ActualAgeToMaxTotalFaceNonUsCitizen: ActualAgeToMaxTotalFaceNonUsCitizenCPL15
                };
            case 'CPL20':
            case 'CPL20A':
                return {
                    ActualAgeToMinTotalFace: lowFaceWholeLifeEnabled ? ActualAgeToMinTotalFaceCPL20LowFaceWholeLifeEnabled : ActualAgeToMinTotalFaceCPL20,
                    ActualAgeToMaxTotalFace: ActualAgeToMaxTotalFaceCPL20,
                    PaymentFrequencyToDividendOptions: PaymentFrequencyToDividendOptionsCPL20,
                    ActualAgeToMaxTotalFaceNonUsCitizen: ActualAgeToMaxTotalFaceNonUsCitizenCPL20
                };
            case 'CPL65':
            case 'CPL65A':
                return {
                    ActualAgeToMinTotalFace: lowFaceWholeLifeEnabled ? ActualAgeToMinTotalFaceCPL65LowFaceWholeLifeEnabled : ActualAgeToMinTotalFaceCPL65,
                    ActualAgeToMaxTotalFace: ActualAgeToMaxTotalFaceCPL65,
                    PaymentFrequencyToDividendOptions: PaymentFrequencyToDividendOptionsCPL65,
                    ActualAgeToMaxTotalFaceNonUsCitizen: ActualAgeToMaxTotalFaceNonUsCitizenCPL65
                };
            case 'CPL100':
            case 'CPL100A':
                return {
                    ActualAgeToMinTotalFace: lowFaceWholeLifeEnabled ? ActualAgeToMinTotalFaceCPL100LowFaceWholeLifeEnabled : ActualAgeToMinTotalFaceCPL100,
                    ActualAgeToMaxTotalFace: ActualAgeToMaxTotalFaceCPL100,
                    PaymentFrequencyToDividendOptions: PaymentFrequencyToDividendOptionsCPL100,
                    ActualAgeToMaxTotalFaceNonUsCitizen: ActualAgeToMaxTotalFaceNonUsCitizenCPL100
                };
            default:
                throw new Error("No config available for ".concat(productCode));
        }
    };
    WholeLifeValidationUtils.getAgeLookUpKeyForActualAge = function (actualAge) {
        //the config is stored in 1/2 year increments so round down to nearest 1/2
        return ValidationUtils_1.ValidationUtils.roundDownToNearestIncrement(actualAge, .5).toFixed(1);
    };
    WholeLifeValidationUtils.isValidAlirPlannedYears = function (value, termYears, insuranceAge) {
        // The minimum number of years is: RiderConstants.alir.plannedYears.min
        // The maximum number of years is: When the policy is paid up
        if (!value || value < Product_1.RiderConstants.alir.plannedYears.min) {
            return {
                isValid: false,
                message: "The minimum is ".concat(Product_1.RiderConstants.alir.plannedYears.min),
            };
        }
        var maxPlannedYears = termYears === 65 || termYears === 100
            ? termYears - insuranceAge
            : termYears;
        if (value > maxPlannedYears) {
            return {
                isValid: false,
                message: "The maximum is ".concat(maxPlannedYears),
            };
        }
        return { isValid: true };
    };
    WholeLifeValidationUtils.isValidAlirAmount = function (amount, unscheduledAmount, policyFaceAmount, rtrAmount, insuranceAge, actualAge, isUsCitizen, premium, productCode, paymentFrequency, maxFaceAllowed) {
        // validate minimum
        if (ValidationUtils_1.ValidationUtils.exists(amount) && amount < Product_1.RiderConstants.alir.minAnnualScheduledAmount) {
            var message = void 0;
            if (paymentFrequency === 'monthly') {
                message = "The minimum is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.alir.minAnnualScheduledAmount / 12), " per month");
            }
            else {
                message = "The minimum is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.alir.minAnnualScheduledAmount), " per year");
            }
            return {
                isValid: false,
                message: message,
                isGlobalError: false
            };
        }
        if (ValidationUtils_1.ValidationUtils.exists(unscheduledAmount) && unscheduledAmount < Product_1.RiderConstants.alir.minAnnualUnscheduledAmount) {
            return {
                isValid: false,
                message: "The minimum is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.alir.minAnnualUnscheduledAmount)),
                isGlobalError: false,
            };
        }
        var isTotalFaceValid = WholeLifeValidationUtils.validateTotalFaceForAlir(amount || 0, unscheduledAmount || 0, policyFaceAmount, rtrAmount, insuranceAge, actualAge, isUsCitizen, productCode, maxFaceAllowed);
        if (!isTotalFaceValid.isValid) {
            return {
                isValid: false,
                message: isTotalFaceValid.message,
                details: isTotalFaceValid.details,
                isGlobalError: true,
            };
        }
        // scheduled ALIR cannot exceed 10x the base annual premium
        if (ValidationUtils_1.ValidationUtils.exists(amount) && ((amount > premium * 10) || (amount > Product_1.RiderConstants.alir.maxAnnualScheduledAmount))) {
            return {
                isValid: false,
                message: "ALIR error: The scheduled amount cannot exceed 10 times the base annual premium, up to ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.alir.maxAnnualScheduledAmount), "."),
                isGlobalError: true
            };
        }
        // unscheduled ALIR cannot exceed 20x the base annual premium
        if (ValidationUtils_1.ValidationUtils.exists(unscheduledAmount) && ((unscheduledAmount > premium * 20) || (unscheduledAmount > Product_1.RiderConstants.alir.maxAnnualUnscheduledAmount))) {
            return {
                isValid: false,
                message: "1035 error: The 1035 exchange transfer amount cannot exceed 20 times the base annual premium, up to ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.alir.maxAnnualUnscheduledAmount), "."),
                isGlobalError: true
            };
        }
        return {
            isValid: true,
        };
    };
    WholeLifeValidationUtils.validateTotalFaceForAlir = function (scheduledAmount, unscheduledAmount, policyFaceAmount, rtrAmount, insuranceAge, actualAge, isUsCitizen, productCode, maxFaceAllowed) {
        // to get the correct narFactor we need to check if policy.faceAmount + rtrAmount is within the 250k range or not
        // 250k range comes from product.
        var faceAndRtr = policyFaceAmount + rtrAmount;
        var faceSlab = Product_1.RiderConstants.alir.narFactors.find(function (f) { return faceAndRtr < f.totalFaceUpTo; });
        if (faceSlab) {
            var narFactors = faceSlab.ageSlabs.find(function (s) { return insuranceAge <= s.maxAge; });
            if (narFactors) {
                // the formula is: policyFace + rtrAmount + (scheduledAmt * scheduledNarFactor) + (unscheduledAmt * unscheduledNarFactor)
                // if the result of the above is up to 1M/3M (inslusive), we're good. 1M/3M is determined by citizenship status and actual age
                var totalFace = faceAndRtr +
                    scheduledAmount * narFactors.scheduled +
                    unscheduledAmount * narFactors.unscheduled;
                if (!maxFaceAllowed) {
                    maxFaceAllowed = isUsCitizen
                        ? Product_1.RiderConstants.alir.totalFaceCapUsCitizens
                        : Product_1.RiderConstants.alir.totalFaceCapForNonUsCitizens;
                    var config = WholeLifeValidationUtils.getConfigForProduct(productCode);
                    var actualAgeLookUpKey = WholeLifeValidationUtils.getAgeLookUpKeyForActualAge(actualAge);
                    maxFaceAllowed = Math.min(maxFaceAllowed, config.ActualAgeToMaxTotalFace[actualAgeLookUpKey]);
                }
                if (totalFace > maxFaceAllowed) {
                    var maxFaceAllowedDifference = totalFace - maxFaceAllowed;
                    return {
                        isValid: false,
                        message: "The underwriting limit for this client is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(maxFaceAllowed), ". You've exceeded the limit by ").concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(maxFaceAllowedDifference), "."),
                        details: {
                            scheduledAmount: scheduledAmount ? { scheduledAmount: scheduledAmount, scheduledNar: narFactors.scheduled } : 0,
                            unscheduledAmount: unscheduledAmount ? { unscheduledAmount: unscheduledAmount, unscheduledNar: narFactors.unscheduled } : 0
                        },
                    };
                }
                return { isValid: true };
            }
        }
        return {
            isValid: false,
            message: "ALIR configuration incomplete for faceAndRtr: ".concat(faceAndRtr, ", insurance age ").concat(insuranceAge),
        };
    };
    WholeLifeValidationUtils.getScheduledALIRTotal = function (scheduledAmount, faceAndRtr, insuranceAge) {
        var faceSlab = Product_1.RiderConstants.alir.narFactors.find(function (f) { return faceAndRtr < f.totalFaceUpTo; });
        var scheduledALIRTotal;
        if (faceSlab) {
            var narFactors = faceSlab.ageSlabs.find(function (s) { return insuranceAge <= s.maxAge; });
            if (narFactors) {
                scheduledALIRTotal = scheduledAmount * narFactors.scheduled;
            }
        }
        return scheduledALIRTotal || 0;
    };
    WholeLifeValidationUtils.getTotalFaceAmountWithRiders = function (policyFaceAmount, rtrAmount, scheduledAmount, unscheduledAmount, insuranceAge) {
        // to get the correct narFactor we need to check if policy.faceAmount + rtrAmount is within the 250k range or not
        // 250k range comes from product.
        var faceAndRtr = policyFaceAmount + rtrAmount;
        var faceSlab = Product_1.RiderConstants.alir.narFactors.find(function (f) { return faceAndRtr < f.totalFaceUpTo; });
        if (faceSlab) {
            var narFactors = faceSlab.ageSlabs.find(function (s) { return insuranceAge <= s.maxAge; });
            if (narFactors) {
                // the formula is: policyFace + rtrAmount + (scheduledAmt * scheduledNarFactor) + (unscheduledAmt * unscheduledNarFactor)
                // if the result of the above is up to 1M/3M (inslusive), we're good. 1M/3M is determined by citizenship status and actual age
                return (faceAndRtr +
                    WholeLifeValidationUtils.getScheduledALIRTotal(scheduledAmount, faceAndRtr, insuranceAge) +
                    unscheduledAmount * narFactors.unscheduled);
            }
        }
    };
    WholeLifeValidationUtils.getTotalAlirFaceAmount = function (policyFaceAmount, rtrAmount, scheduledAmount, unscheduledAmount, insuranceAge) {
        // to get the correct narFactor we need to check if policy.faceAmount + rtrAmount is within the 250k range or not
        // 250k range comes from product.
        var faceAndRtr = policyFaceAmount + rtrAmount;
        var faceSlab = Product_1.RiderConstants.alir.narFactors.find(function (f) { return faceAndRtr < f.totalFaceUpTo; });
        if (faceSlab) {
            var narFactors = faceSlab.ageSlabs.find(function (s) { return insuranceAge <= s.maxAge; });
            if (narFactors) {
                // the formula is: (scheduledAmt * scheduledNarFactor) + (unscheduledAmt * unscheduledNarFactor)
                // if the result of the above is up to 1M/3M (inclusive), we're good. 1M/3M is determined by citizenship status and actual age
                return (WholeLifeValidationUtils.getScheduledALIRTotal(scheduledAmount, faceAndRtr, insuranceAge) +
                    unscheduledAmount * narFactors.unscheduled);
            }
        }
    };
    return WholeLifeValidationUtils;
}());
exports.WholeLifeValidationUtils = WholeLifeValidationUtils;
